import { CacheCarePlanItemResponse } from "./cacheCarePlanItemResponse.class";
import { CacheCarePlanItemHistory } from "./cacheCarePlanItemHistory.class";

export class CacheCarePlanItem
{
    public PlanID: number;
    public ItemType: number;
    public VisitItemID: number;
    public ReportedValue: string;
    public MemberPlanId: number;
    public ItemDescription: string;
    public ServiceOrderId: number;
    public Note: string;
    public IsAdditionalItem : boolean;
    public Responses: CacheCarePlanItemResponse[];
    public showHistory: boolean = false;
    public History: CacheCarePlanItemHistory[] = [];
    public IncludeNotesBoxOption: boolean;
    public ItemNotes: string = '';
    constructor(
        obj: CacheCarePlanItem
    )
    {
        this.PlanID = obj.PlanID
        this.ItemType = obj.ItemType
        this.VisitItemID = obj.VisitItemID
        this.ReportedValue = obj.ReportedValue
        this.MemberPlanId = obj.MemberPlanId
        this.ItemDescription = obj.ItemDescription
        this.ServiceOrderId = obj.ServiceOrderId
        this.Responses = obj.Responses
        this.Note = obj.Note
        this.IsAdditionalItem = obj.IsAdditionalItem
        this.History = obj.History == undefined ? [] : obj.History;
        this.IncludeNotesBoxOption = obj.IncludeNotesBoxOption == undefined ? false : obj.IncludeNotesBoxOption;
        this.ItemNotes = obj.ItemNotes == undefined ? '': obj.ItemNotes;
    }
}